import React, { useEffect } from "react";
import { connect } from "react-redux";
import intl from "react-intl-universal";
import { withRouter } from "react-router-dom";
import { QRCode, Button, message } from "antd";
import copyBatch from "@/utils/copy";
import { getInfo } from "@/actions/auth";
import leftlogo from "@/assets/image/leftlogo.png";

import styles from "./index.module.scss";

const MobileInvite = (props) => {
  // const inviteLink = `${window.location.origin}/register?code=${props.invitationCode}`;
  const inviteLink = `https://h5.9five.cn?invitationCode=${props.invitationCode}`;

  useEffect(() => {
    props.getInfo();
  }, []);
  const handleCopyLink = () => {
    copyBatch(inviteLink);
    message.success(intl.get("mobileInvite_linkCopied"));
  };

  return (
    <div className={styles.contentContainer}>
      <img src={leftlogo} className={styles.logo} alt="" />
      <div className={styles.title}>
        {intl.get("mobileInvite_inviteNewUser")}
        <br />
        {intl.get("mobileInvite_getRebate")}
      </div>
      <div className={styles.inviteSection}>
        <div className={styles.qrCodeSection}>
          <p>{intl.get("mobileInvite_myInviteCode")}</p>
          <QRCode
            value={inviteLink}
            style={{ background: "#fff" }}
            size={200}
          />
        </div>
        <div className={styles.inviteLinkSection}>
          <p className={styles.title}>
            {intl.get("mobileInvite_myInviteLink")}
          </p>
          <p>{inviteLink}</p>
          <Button
            type="primary"
            className={styles.copyBtn}
            onClick={handleCopyLink}
          >
            {intl.get("mobileInvite_copyInviteLink")}
          </Button>
        </div>
      </div>
      <p className={styles.tip}>{intl.get("mobileInvite_pcLoginNotice")}</p>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { invitationCode } = state.auth;
  return {
    invitationCode,
  };
};

export default withRouter(connect(mapStateToProps, { getInfo })(MobileInvite));
